module.exports = __webpack_public_path__ + "static/media/locations.fb0be475.svg";